<template>
    <div class="register">
        <div class="login-box">
            <h1 class="registertitle">注册</h1>
            <Card class="login-form">
                <Form :model="loginForm" :rules="loginRules" ref="loginForm">
                    <FormItem prop="username" ref="login_username">
                        <Input v-model="loginForm.username" type="text" prefix="ios-contact" @on-enter="login"
                               placeholder="用户名" :autocomplete="state"></Input>
                    </FormItem>
                    <FormItem prop="password" ref="login_password">
                        <Input v-model="loginForm.password" type="password" prefix="md-key" @on-enter="login"
                               placeholder="密码" :autocomplete="state"></Input>
                    </FormItem>
                    <FormItem prop="pwdCheck" ref="login_pwdCheck">
                        <Input v-model="loginForm.pwdCheck" type="password" prefix="md-key" @on-enter="login"
                               placeholder="再次输入密码" :autocomplete="state"></Input>
                    </FormItem>
                    <FormItem prop="email" ref="login_email">
                        <Input v-model="loginForm.email" type="text" prefix="md-at" @on-enter="login"
                               placeholder="您的常用邮箱" :autocomplete="state"></Input>
                    </FormItem>
                    <FormItem prop="verification" ref="login_verification">
                        <Input v-model="loginForm.verification" placeholder="验证码" style="width: 40%;float: left"/>
                        <Button type="success" :disabled="auth_time !== 0" @click="getAuthCode "><span
                                v-show="auth_time > 0" class="auth_text_blue">{{auth_time}} </span>获取邮箱验证码
                        </Button>
                    </FormItem>
                </Form>
                <Button type="success" long @click="login">注册</Button>
                <router-link style="margin-right: 75%;" to="/home"><<<< 登录</router-link>
            </Card>
        </div>
    </div>
</template>

<script>
    import {verification_api, register_api, verifi_api} from '../../api/login/login'
    import {Card, Form, FormItem, Input, Button, Message} from 'iview'
    import {auth_key} from './../../config'

    export default {
        name: 'register',
        components: {
            Card,
            Form,
            FormItem,
            Input,
            Button,
            Message
        },
        data() {

            const pwdCheckValidate = (rule, value, callback) => {
                if (this.loginForm.password != '' && value == '') {
                    callback(new Error('确认密码不能为空'))
                } else if (this.loginForm.password != value) {
                    callback(new Error('新密码和确认密码不相同'))
                } else {
                    callback()
                }
            }

            return {
                state: 'off',
                value: '',
                run: '',
                auth_time: 0,
                loginForm: {
                    username: '',
                    password: '',
                    pwdCheck: '',
                    email: '',
                    verification: '',
                },
                loginRules: {
                    username: [
                        {required: true, message: '用户名不能为空', trigger: 'blur'},
                        {
                            type: 'string',
                            min: 4,
                            max: 20,
                            message: '4-20小写字母、数字或汉字组成',
                            pattern: '[a-z0-9\u4E00-\u9FFF]'
                        },
                    ],
                    password: [
                        {required: true, message: '密码不能为空', trigger: 'blur'},
                        {type: 'string', min: 6, max: 20, message: '请输入6-20个字符'},
                    ],
                    pwdCheck: [
                        {required: true, trigger: 'blur', validator: pwdCheckValidate},
                    ],
                    email: [
                        {required: true, message: '请输入邮箱', trigger: 'blur'},
                        {
                            type: 'string',
                            message: '邮箱很重要，请正确填写，确保您能接收审核邮件以及其他站内邮件',
                            pattern: '([a-zA-Z0-9]*@[a-zA-Z0-9]*\\.[a-zA-Z]{3}\\;?)+'
                        },
                    ],
                    verification: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            login() {
                if (this.loginForm.verification !== '') {
                    verifi_api(this.loginForm.email).then(_data => {
                        let res = _data.body
                        if (res.code === 0) {
                            this.$Message.error({
                                content: res.msg
                            })
                            return
                        } else {
                            if (this.loginForm.verification === res.code) {
                                let _bool = this.$refs.loginForm.validate()
                                // 验证通过
                                if (_bool) {
                                    this.$Message.loading({
                                        content: '登录中',
                                        duration: 0
                                    })
                                    register_api(this.loginForm).then(_data => {
                                        let res = _data.body
                                        if (res.code === 0) {
                                            this.$Message.destroy()
                                            this.$Message.error({
                                                content: res.msg
                                            })
                                        } else {
                                            this.$Message.destroy()
                                            // console.log(123456789)
                                            sessionStorage.setItem(auth_key, res.key)
                                            // console.log(sessionStorage.getItem(auth_key))
                                            this.$router.push({name: 'home'})
                                        }
                                    })
                                }
                            } else {
                                this.$Message.error({
                                    content: '验证码错误'
                                })
                                return
                            }
                        }
                    })
                } else {
                    this.$Message.error({
                        content: '请输入验证码'
                    })
                    return
                }
            },

            // 获取验证码倒计时读秒
            getAuthCode: function () {
                // 请求发送验证
                if (this.loginForm.email == '') {
                    alert('请填写邮箱！')
                    return false
                } else {
                    verification_api(this.loginForm.email).then(_data => {
                            let data = _data.body
                            if (data.code === 0) {
                                this.$Message.success({
                                    content: data.msg,
                                    onClose(){
                                        this.$Message.warning({
                                            content: '部分邮件请到邮箱垃圾箱寻找',
                                            duration:5
                                        })
                                    }
                                })
                            } else if (data.code === 1) {
                                this.$Message.error({
                                    content: data.msg
                                })
                            }
                        },
                    )
                }

                // 读秒
                this.auth_time = 600
                var auth_timetimer = setInterval(() => {
                    this.auth_time--
                    if (this.auth_time <= 0) {
                        clearInterval(auth_timetimer)
                    }
                }, 1000)
            }
        },
    }
</script>

<style lang="scss">
    .register {
        width: 100%;
        height: 100vh;
        padding-top: 15vh;
    }

    .login-box {
        width: 350px;
        margin: auto;
        text-align: center;

        .registertitle {
            color: #19be6b;
            font-size: 2rem;
            margin-bottom: 15px;
        }

        .login-form {
            background-color: #fdfdfd;
        }
    }
</style>
